// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Html5OutlinedSvg from "@fishx/icons-svg/es/asn/Html5Outlined";
import FishxIcon from '../components/FishxIcon';

var Html5Outlined = function Html5Outlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: Html5OutlinedSvg
  }));
};

Html5Outlined.displayName = 'Html5Outlined';
export default React.forwardRef(Html5Outlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/Html5Outlined.js
// module id = 2950
// module chunks = 0